import { produce } from 'immer';
import React, { useEffect, useState } from 'react';
import { Dialog } from 'tdesign-react';
import { CLUSTER_TYPES } from '@/utils/constant';
import ScriptTable, { defaultColumns } from '@/pages/Maintenance/Template/components/ScriptTable';

const columns = produce(defaultColumns, (draft) => {
  draft[0].type = 'single';
});

export default function SelectScriptModal({ visible, handleClose, isK8s }) {
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (visible) {
      setSelectedRows([]);
    }
  }, [visible]);

  const onConfirm = () => {
    handleClose(selectedRows[0]);
  };

  const onSelectChange = (value, { selectedRowData }) => {
    setSelectedRows(selectedRowData);
  };

  const afterLoadData = (datas) => {
    setSelectedRows([]);
    return datas;
  };

  return (
    <Dialog
      header='选择脚本'
      visible={visible}
      onClose={() => handleClose()}
      onConfirm={onConfirm}
      placement='center'
      destroyOnClose
      width={'80%'}
    >
      <ScriptTable
        selectOnRowClick
        columns={columns}
        selectedRowData={selectedRows}
        onSelectChange={onSelectChange}
        afterLoadData={afterLoadData}
        extraPrams={{
          scriptOriginal: isK8s ? [CLUSTER_TYPES.K8S] : [CLUSTER_TYPES.HOST],
        }}
      />
    </Dialog>
  );
}
